import React, { useState, useEffect } from "react";
import { addCommas, bindClick, cropString, fromUnix } from "@arema/components/Util";
import { Button, Groupper, Header, Table, Icon, Input, Label } from 'react-frontier2';
import { useTitle } from "@arema/components/Hooks";
import { Link, useNavigate } from "react-router-dom";
import { SearchEventModal } from "../../components";
import { CatalogEvent, EventDate } from "@arema/components/Classes";
import { SearchOrder } from "../../AdminClasses";
import classNames from "classnames";
import moment from "moment";
import API from "../../API";
import '../../style/catalog.scss';
import '../../style/order_list.scss';

var OrderList = ()=>{
	var [recentOrders, setRecentOrders] = useState<SearchOrder[]>(null);
	var [searchOrders, setSearchOrders] = useState<SearchOrder[]>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [searchQuery, setSearchQuery] = useState<string>('');
	var [searchedQuery, setSearchedQuery] = useState<string>(null);
	var [ordersError, setOrdersError] = useState<string>(null);
	var [eventsModal, setEventsModal] = useState<boolean>(false);
	var { setTitle } = useTitle();
	var navigate = useNavigate();

	useEffect(()=>{
		if(!recentOrders){
			API.getRecentOrders().then(res=>{
				if(res.error) return setOrdersError(res.message);
				setRecentOrders(res.data);
			}).catch(err=>{
				return setOrdersError('Hubo un error inesperado cargando las ordenes recientes.');
			});
		}
		setTitle('Ordenes')
	}, [recentOrders]);

	var onSearchChange = (v: string)=>{
		setSearchQuery(v);
		if(searchOrders!==null && v.length==0){
			setSearchedQuery(null);
			setSearchOrders(null);
		}
	}
	
	var search = ()=>{
		if(searching || (searchQuery.length<=3 && !searchQuery.startsWith('@'))) return;
		setSearching(true);
		setOrdersError(null);
		setSearchedQuery(searchQuery);
		API.searchOrders(searchQuery).then(res=>{
			if(res.error) return setOrdersError(res.message);
			setSearchOrders(res.data);
		}).catch(err=>{
			setOrdersError('Hubo un error buscando las ordenes. (LCL-1)');
		}).finally(()=>{
			setSearching(false);
		})
	}

	var onEventSelected = (event: CatalogEvent, date: EventDate)=>{
		navigate(`/orders/create/${date.date_id}`);
		return true;
	}

	return <div>
		<Groupper title="Ordenes" style={{ maxWidth: 1000, paddingBottom: 0, overflow: 'hidden' }} titleRight={(
			<Button size="tiny" color="black" text="Crear" iconName="plus-circle" onClick={bindClick(setEventsModal, true)} />
		)}>
			<Input placeholder="Buscar orden..." value={searchQuery} onChange={onSearchChange} onSubmit={search} buttons={(
				<Button text="Buscar" onClick={search} />
			)} />
			<Table fitted style={{ marginTop: 20 }} last>
				<Table.Head
					data={[['ID', 'Fecha', 'Nombre', 'Correo', 'Estatus', 'Total']]}
					collapsingIndexes={[0, 1, 4, 5]}
				/>
				<Table.Body>
					{ordersError ? (
						<Table.Cell row selectable={false} colSpan={100}>
							<Header text="Error" subtext={ordersError} style={{ padding: 15, margin: '50px 0' }} />
						</Table.Cell>
					) : searching ? (
						<Table.Cell row selectable={false} colSpan={100}>
							<Header loading text="Buscando ordenes..." style={{ margin: '50px 0' }} />
						</Table.Cell>
					) : (recentOrders || searchOrders) ? (
						(searchOrders || recentOrders).length==0 ? (
							<Table.Cell row colSpan={100} selectable={false}>
								<Header text="No se encontraron ordenes" subtext={searchedQuery ? `Buscando: ${searchedQuery}` : null} size="small" style={{ margin: '20px 0' }} />
							</Table.Cell>
						) : (searchOrders || recentOrders).map(a=>{
							var StatusLabel = <Label color={classNames({
								red: a.cancelled,
								transparent: !a.cancelled && a.expired && !a.paid,
								green: !a.cancelled && a.paid,
								blue: !a.cancelled && !a.paid && !a.expired,
							}) as any}>
								{a.cancelled ? 'Cancelado' : (a.expired ? 'Expirado' : (a.paid ? 'Pagado' : 'Pendiente'))}
							</Label>
							return (
								<Table.Row selectable key={`ord-${a.order_hash}`} to={`/orders/${a.order_hash}`} as={Link} compact >
									<Table.Cell collapsing value={a.order_hash} className="fr mono"></Table.Cell>
									<Table.Cell collapsing value={fromUnix(parseInt(a.date)).toFormat('dd/MM/yy HH:mm')} />
									<Table.Cell>
										{(!a.email || a.email.length==0) ? (
											<Icon name="minus" color="gray" />
										) : a.pdv_id && (!a.email || a.email.length==0) ? (
											'Venta PDV'
										) : (
											(a.first_name || a.last_name) ? cropString(`${a.first_name || ''} ${a.last_name || ''}`, 20, true) 
											: <Icon name="minus" color="gray" />
										)}
									</Table.Cell>
									<Table.Cell value={a.email} />
									<Table.Cell collapsing value={StatusLabel} />
									<Table.Cell centered={a.cancelled || a.expired}>
										{a.cancelled || a.expired ? (
											<Icon name="minus" color="gray" />
										) : addCommas(a.total)}
									</Table.Cell>
								</Table.Row>
							)
						})
					) : (
						<Table.Cell row colSpan={100} selectable={false}>
							<Header loading text="Cargando ordenes..." style={{ margin: '50px 0' }} />
						</Table.Cell>
					)}
				</Table.Body>
			</Table>
		</Groupper>
		<SearchEventModal date open={eventsModal} onClose={bindClick(setEventsModal)} onDateSelected={onEventSelected} />
	</div>
}

export default OrderList;